<template>
    <el-row :gutter="30" class="mw-100">
        <el-col :lg="24" :xs="24">
            <div class="mb-20 d-flex ">
                <!-- <el-button type="primary" @click="handleAddPagesBanner" class="ml-auto">
                    <span class="color-white">
                        add pagesBanner
                    </span>
                </el-button> -->
            </div>
            <el-card class="box-card">
                <el-table :data="pagesBanners" style="width: 100%">
                    
                    
                    
                    <el-table-column label="image" prop="imageURL" width="80" >
                        <template #default="scope">
                            <el-image 
                                style="width: 50px; height: 50px" 
                                :src="$getImage(scope.row.imageURL) || ''" 
                                fit="cover"
                                :zoom-rate="1.2"
                                :preview-src-list="[$getImage(scope.row.imageURL)]"
                                :preview-teleported="true"
                            >
                                <template #error>
                                    <div class="image-slot">
                                        <font-awesome-icon :icon="['fas', 'image']" />
                                    </div>
                                </template>
                            </el-image>
                        </template>
                    </el-table-column>
                    
                    <el-table-column label="title En" >
                        <template #default="scope">
                           {{$getLocaleData(scope.row.translates,'en_us').title}}
                        </template>
                    </el-table-column>
                    <el-table-column label="description En" >
                        <template #default="scope">
                           {{$getLocaleData(scope.row.translates,'en_us').description}}
                        </template>
                    </el-table-column>

                    <el-table-column label="title Ar" class-name="text-right rtl">
                        <template #default="scope">
                           {{$getLocaleData(scope.row.translates,'ar_sa').title}}
                        </template>
                    </el-table-column>
                    
                    <el-table-column label="description Ar" class-name="text-right rtl">
                        <template #default="scope">
                           {{$getLocaleData(scope.row.translates,'ar_sa').description}}
                        </template>
                    </el-table-column>

                    
                    <el-table-column label="Operations" width="100">
                        <template #default="scope">
                            <el-tooltip
                                class="box-item"
                                effect="dark"
                                content="edit product"
                                placement="top"
                            >
                                <font-awesome-icon :icon="['fas', 'edit']" style="width:20px" @click="handleEditPagesBanner(scope.row)" class="cursor-pointer" />
                            </el-tooltip>
                             
                                
                        </template>
                    </el-table-column>
                </el-table>
               
            </el-card>
        </el-col>
    </el-row>
</template>
<script>
export default {
    computed:{
        cachedPagesBanners(){
            return JSON.parse(localStorage.getItem('adminStore'))?.website?.settings?.pagesBanners?.list || []
        },
    },
    data(){
        return{
            pagesBanners:[],
            pagesBannerStatus:[],
           
        }
    },
    async mounted(){
        if (!this.cachedPagesBanners?.length){
            this.getAllPagesBanners();
        }else{
            this.pagesBanners = this.cachedPagesBanners;
          
        }
        
       
    },
    
    methods:{
       
        async getAllPagesBanners(){
            const response = await this.$store.dispatch('getAllPagesBanners');

            this.pagesBanners = response;
             
        },
        async changePagesBannerStatus(pagesBanner){
            const response = await this.$store.dispatch('changePagesBannerStatus',pagesBanner.id);
            if (response.data.status == 1){
         
                this.getAllPagesBanners();
                this.$notify({
                    title:String(response.status),
                    message:response.data.message,
                    type:'success',
                });
            }else{
                let currentPagesBannerIndex = this.pagesBanners.findIndex(prt => prt.id == pagesBanner.id);
                this.pagesBanners[currentPagesBannerIndex].active = !this.pagesBanners[currentPagesBannerIndex].active 
                // this.pagesBanners.splice(currentPagesBannerIndex,1);
            }
             
        },
        async handleAddPagesBanner(){
            this.$router.push({
                name:'manage-pages-banner',
            })
           
        },
        async handleEditPagesBanner(pagesBanner){
            await this.$store.dispatch('storeCurrentPagesBannerToView',pagesBanner)
            this.$router.push({
                name:'manage-pages-banner',
                params:{
                    id:pagesBanner.id
                }
            })
        },
      
    
       
        
    }
}
</script>
<style lang="scss">
    .text-right.rtl {
        .cell {
            text-align: right;
            direction: rtl;
        }
    }
</style>